import "./timeline.styles.scss";
import eventImage from "../../assets/images/table_mountain.jpg"

const Timeline = () => {
    const events = [
      { date: "2024-01-01", content: "Event 1" },
      { date: "2024-02-01", content: "Event 2" },
      { date: "2024-03-01", content: "Event 3" },
      { date: "2024-04-01", content: "Event 4" },
      { date: "2024-04-01", content: "Event 4" },
      { date: "2024-04-01", content: "Event 4" },
    ];
  
    return (
      <div className="timeline">
        {events.map((event, index) => (
          <div className="timeline__event">
            <div className="timeline__event-description" key={index}>
              <div className="timeline__event-photo">
                <a href="/events/details" target="_top"><img src={eventImage} alt="event image"></img></a>
              </div>
              
              <div className="timeline__event-details">
                <p className="event-card__tags event-card__tags-small">
                    <span className="event-card__tags-1">challenging</span>
                    <span className="event-card__tags-2">child friendly</span>
                    <span className="event-card__tags-3">Day hike</span>
                </p>
                <p className="timeline__event-location u-margin-top-tiny"><i className="fa-solid fa-location-dot"></i> Nyandarua, Kenya</p>
                <h3 className="timeline__event-name ">Table Mountain, Arberdare</h3>
                <p className="timeline__event-date">16th Nov 2024</p>
                <p className="timeline__event-price">Ksh 3,500/= per head</p>
              </div>
          </div>
        </div>
        ))}
      </div>
    );
  };
  
  export default Timeline;